// Leaf module — kept free of any dependency on schemas.ts or utils.ts so both can import
// from here without creating a circular import between them.
export interface TouchableCpoDeliveryDateLineFields {
  deliverByDate: string | null
}

// All other fields (shipFromLocationId, shipByDate, soPallets, soUnits, soUom, isManualPriceSet,
// etc.) are optional until Delivery Date is set — deliverByDate is the single FE signal a line is
// a "real" line. The BE's own Sales Order grouping key is broader (ship-from + deliver-date
// together, see SalesOrderGroupingService) — this is a separate, FE-only heuristic used for
// VALIDATION GATING only (schemas.ts refines) — do not use this to decide what gets included in
// the save payload. See hasCpoDeliveryDateLineData for that.
export const isCpoDeliveryDateLineTouched = (line: TouchableCpoDeliveryDateLineFields): boolean =>
  line.deliverByDate !== null

export interface DataCpoDeliveryDateLineFields {
  shipFromLocationId: string | null
  defaultShipFromLocationId: string | null
  shipByDate: string | null
  deliverByDate: string | null
  soPallets: number | null
  soUnits: number | null
  soUom: string | null
  defaultSoUom: string | null
  isManualPriceSet: boolean
}

// PERSISTENCE GATE — used by toCustomerPurchaseOrderProductUpsertInputs to decide which
// delivery-date lines to include in the Save payload. Broader than isCpoDeliveryDateLineTouched
// on purpose: a line can have real edits (Ship From, SO UoM, price override) before a Deliver By
// Date is ever set, and those edits must not be dropped.
// shipFromLocationId/soUom start out pre-filled with company defaults, not null — so a brand-new,
// untouched line already has non-null values there. Comparing against the stored default
// (defaultShipFromLocationId/defaultSoUom) instead of null is what tells "still the auto-filled
// default" apart from "the user actually changed this."
export const hasCpoDeliveryDateLineData = (line: DataCpoDeliveryDateLineFields): boolean =>
  line.shipByDate !== null ||
  line.deliverByDate !== null ||
  line.soPallets !== null ||
  line.soUnits !== null ||
  line.isManualPriceSet ||
  line.shipFromLocationId !== line.defaultShipFromLocationId ||
  line.soUom !== line.defaultSoUom
